import { Common } from "./type";

export const VI_COMMON: Common = {
  loading: "Đang tải...",
  error: "Lỗi",
  success: "Thành công",
  cancel: "Hủy",
  save: "Lưu",
  edit: "Chỉnh sửa",
  delete: "Xóa",
  confirm: "Xác nhận",
  back: "Quay lại",
  next: "Tiếp theo",
  previous: "Trước đó",
  submit: "Gửi",
  close: "Đóng",
  yes: "Có",
  no: "Không",
  copy: "Sao chép",
  copied: "Đã sao chép",
  retry: "Thử lại",
  confirming: "Đang xác nhận...",
  declining: "Đang từ chối...",
  submitting: "Đang gửi...",
  saving: "Đang lưu...",
  done: "Xong",
  name: "Tên",
  email: "Email",
  date: "Ngày",
  type: "Loại",
  status: "Trạng thái",
  unit: "xu",
  and: "và"
};
